import React from 'react';
import GoogleMap from './GoogleMap';
import { decodePolygon } from "../utils";
import { getColors } from "../constants";


class MapContainer extends React.Component {
  constructor(props) {
    super(props);
    this.mapLoaded = false;
    this.state = {...this.state, height: this.height()};
    window.onresize = this.onResize;
    this.colors = getColors(props.theme);
  }

  static preparePolygon = (polygon, useDecode = true) => {
    if (useDecode) {
      return decodePolygon(polygon);
    } else {
      return polygon;
    }
  };

  onResize = () => {
    this.setState({...this.state, height: this.height()});
  };

  height = () => {
    return window.innerHeight - 54 - 42;
  };

  handleMapLoad = (map) => {
    this._mapComponent = map;
    // load regions from server only at the first time
    if (map && this.props.initCallback && !this.mapLoaded) {
      this.mapLoaded = true;
      this.props.initCallback(map);
    }
  };

  handleMapClick = (e) => {
    if (this.props.mapClick !== undefined) {
      this.props.mapClick(e.latLng.lat(), e.latLng.lng());
    }
  };

  commonOptions(shape, color) {
    return {
      map: this._mapComponent,
      options: {
        strokeColor: color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: color,
        fillOpacity: 0.35,
        geodesic: true,
        id: shape.id,
      },
      onClick: this.props.onPolygonClick,
      onDragPolygon: this.props.onDragPolygon
    };
  }

  preparePolygons(polygons) {
    if (!polygons) {
      return [];
    }
    return polygons.map(polygon => {
      let color = polygon.isSolved ? this.colors.SOLVED : this.colors.WRONG;
      let result = this.commonOptions(polygon, color);
      result.key = `${polygon.draggable}${polygon.id}`;
      result.options.draggable = polygon.draggable;
      result.options.zIndex = polygon.draggable ? 2 : 1;
      result.paths = polygon.paths;
      return result;
    });
  }

  preparePoints(locations) {
    if (!locations) {
      return [];
    }
    let scale = this.props.zoom - 2;
    return locations.map(location => {
      let color = location.isChecking ? this.colors.CHECKING : (location.isSolved ? this.colors.SOLVED : (location.draggable ? this.colors.UNKNOWN : this.colors.WRONG));
      let result = this.commonOptions(location, color);
      result.key = `${location.id}`;
      result.center = location.point;
      result.radius = 90000 / scale / Math.log(scale + 3);
      return result;
    });
  }

  showMarker(infobox) {
    if (infobox) {
      return {
        key: 'center',
        defaultAnimation: 2,
        position: {
          lat: infobox.marker.lat,
          lng: infobox.marker.lng
        }
      }
    }
  }

  render() {
    let props = {...this.props};
    if (!this.props.showMap) {
      return null;
    }
    return <GoogleMap {...props}
                      mapElement={<div style={{height: this.state.height, margin: 0, padding: 0}} id="map"/>}
                      onMapLoad={this.handleMapLoad}
                      onMapClick={this.handleMapClick}
                      polygons={this.preparePolygons(this.props.regions)}
                      points={this.preparePoints(this.props.points)}
                      marker={this.showMarker(this.props.infobox)}
    />;
  }
}


export default MapContainer;
